/**
 * Semantic Versioning comparison utilities.
 *
 * Ensures deterministic evaluation of application updates across platforms.
 */

export function compareSemver(remote: string, current: string): number {
  const clean = (v: string) => v.trim().replace(/^v/i, '');
  const parse = (v: string) =>
    clean(v)
      .split('.')
      .map((seg) => {
        const num = parseInt(seg, 10);
        return isNaN(num) ? 0 : num;
      });

  const [rMaj = 0, rMin = 0, rPatch = 0] = parse(remote);
  const [cMaj = 0, cMin = 0, cPatch = 0] = parse(current);

  if (rMaj !== cMaj) return rMaj - cMaj;
  if (rMin !== cMin) return rMin - cMin;
  return rPatch - cPatch;
}

/**
 * Returns true ONLY if `remote` is strictly higher than `current`.
 * e.g., 1.1.0 > 1.0.10 -> true
 *       1.0.10 > 1.0.10 -> false
 *       1.0.9 > 1.0.10 -> false
 */
export function isStrictlyNewerVersion(remote: string, current: string): boolean {
  if (!remote || !current) return false;
  return compareSemver(remote, current) > 0;
}
